<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">微信审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>人工审核：</label>
          <el-select v-model="state" placeholder="请选择" size="mini" style="width: 7em;" :disabled="noUseState">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>通过码状态：</label>
          <el-select v-model="isUse" placeholder="请选择" size="mini" style="width: 7em;" :disabled="noUseState">
            <el-option v-for="item in isUseArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>通过码：</label>
          <el-select v-model="throughCode" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in throughCodeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>微信总状态：</label>
          <el-select v-model="totalState" placeholder="请选择" size="mini" style="width: 7em;" @change="UseState()">
            <el-option v-for="item in totalStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>上架状态：</label>
          <el-select v-model="isDel" value-key="value" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in isDelStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>验证状态：</label>
          <el-select v-model="isVerify" value-key="value" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in isVerifyArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>展示状态：</label>
          <el-select v-model="showState" value-key="value" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in showStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏状态：</label>
          <el-select v-model="hideState" value-key="value" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in hideStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="请选择" size="mini" style="width: 8em;">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>用户标签：</label>
          <el-select v-model="userTag" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in userTagArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button v-show="state != 2" type="primary" @click="batchPass" v-loading="passLoading">批量通过</el-button>
          <el-button v-show="state != 3" type="danger" @click="batchReject">批量不通过</el-button>
          <el-button type="success" @click="batchShowHide(1)" v-loading="showLoading">批量展示</el-button>
          <el-button type="warning" @click="batchShowHide(2)" v-loading="hideLoading">批量待审时隐藏</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" min-width="100">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" min-width="204">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
              <p>渠道：{{ scope.row.channel }}</p>
              <p>微信下载次数：{{ scope.row.downloadNum }}</p>
            </template>
          </el-table-column>
          <el-table-column property="toDownloadNum" label="被下载次数" v-if="checkColList.indexOf('被下载次数') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #3a8ee6">{{ scope.row.toDownloadNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1" min-width="120">
            <template #default="scope">
              <p>{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column label="微信二维码" v-if="checkColList.indexOf('微信二维码') > -1" min-width="100">
            <template #default="scope">
              <GetPlain :url="scope.row.img" :uid="scope.row.uid" :type="11" :subType="0"/>
            </template>
          </el-table-column>
          <el-table-column label="人工审核" v-if="checkColList.indexOf('人工审核') > -1">
            <template #default="scope">
              <span>{{scope.row.state==1?'待审核':scope.row.state==2?'已通过':scope.row.state==3?'不通过':''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="通过码" min-width="60">
            <template #default="scope">
              <P>{{scope.row.isUse==0?'未使用':scope.row.isUse==2?'无使用权限':scope.row.isUse==1?'已使用'+scope.row.throughCode:''}}</P>
            </template>
          </el-table-column>
          <el-table-column label="状态" v-if="checkColList.indexOf('状态') > -1" min-width="160">
            <template #default="scope">
              <p>总状态：{{scope.row.totalState==0?'未提交':scope.row.totalState==1?'待审核':scope.row.totalState==2?'已通过':scope.row.totalState==3?'未通过':''}}</p>
              <p>展示状态：{{scope.row.showState==0?'待展示':scope.row.showState==1?'展示中':scope.row.showState==2?'待审时隐藏':''}}</p>
              <p>上架状态{{scope.row.isDel == 0?'已上架':scope.row.isDel == 1?'已下架':''}}</p>
              <p>被下载上限{{scope.row.dayDown == -1?'不限':scope.row.dayDown + '次/天'}}</p>
              <p>{{scope.row.isVerify?'被下载前需要验证':'被下载前无需验证'}}</p>
              <p style="color: red" v-if="scope.row.hideState != 0">{{ scope.row.hideState == 1?'全平台隐藏':scope.row.hideState == 2?'对被屏蔽用户隐藏':''}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space direction="vertical" alignment="left" :size="6">
                <el-button v-show="scope.row.state == 1 || scope.row.state == 3" type="primary" size="small" @click="singlePass(scope.$index,scope.row)" v-loading="scope.row.sPassLoading">通过</el-button>
                <el-button v-show="scope.row.state == 1 || scope.row.state == 2" type="danger" size="small" @click="singleReject(scope.$index, scope.row)">不通过</el-button>
                <el-button v-show="scope.row.showState == 0 || scope.row.showState == 2" type="success" size="small" @click="singleShowHide(1, scope.$index, scope.row)" v-loading="scope.row.sShowLoading">展示</el-button>
                <el-button v-show="scope.row.showState == 0 || scope.row.showState == 1" type="warning" size="small" @click="singleShowHide(2, scope.$index, scope.row)" v-loading="scope.row.sHideLoading">待审时隐藏</el-button>
                <el-button type="danger" size="small" @click="updateHideState(scope.row)">隐藏微信</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getWeChatPageList,
  batchUpdateWeChatState,
  batchUpdateWeChatShowState,
  getCommonSysParam
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessage from "@/components/SendSystemMessage";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common, auth} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import GetPlain from "@/components/resume/GetPlain";
import WeChatRejectDialog from "./components/WeChatRejectDialog";
import CopyNumDialog from "./components/CopyNumDialog";
import HideStateDialog from "@/views/wechat/components/HideStateDialog";

export default {
  name: "WeChatReview",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain },
  data() {
    return {
      sexArray: common.sexList,
      sex: common.sexList[2]['value'],

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[0]['value'],

      stateArray: [
        {label:"待审核",value:1},
        {label:"不限制",value:-1},
        {label:"未提交",value:0},
        {label:"已通过",value:2},
        {label:"未通过",value:3}
      ],
      state: 1,

      //通过码状态
      isUseArray:[
        {label: '不限', value: -1},
        {label: '未使用', value: 0},
        {label: '已使用', value: 1},
        {label: '无使用权限', value: 2}
      ],
      isUse: -1,

      //通过码
      throughCodeArray:[
        {label:'不限', value:''}
      ],
      throughCode: '',

      //微信总状态
      totalStateArray:[
        {label:"不限制",value:-1},
        {label:"未提交",value:0},
        {label:"审核中",value:1},
        {label:"已通过",value:2},
        {label:"未通过",value:3}
      ],
      totalState: -1,

      //上架状态
      isDelStateArray:[
        {label:"不限",value:-1},
        {label:"已上架",value:0},
        {label:"已下架",value:1},
      ],
      isDel: -1,

      //验证状态
      isVerifyArray:[
        {label:"不限",value:-1},
        {label:"不开启",value:0},
        {label:"开启",value:1},
      ],
      isVerify: -1,

      //展示状态
      showStateArray:[
        {label:"不限",value:-1},
        {label:"待展示",value:0},
        {label:"展示",value:1},
        {label:"待审时隐藏",value:2},
      ],
      showState: -1,

      //展示状态
      hideStateArray:[
        {label:"不限",value:-1},
        {label:"不隐藏",value:0},
        {label:"全平台隐藏",value:1},
        {label:"对被屏蔽用户隐藏",value:2},
      ],
      hideState: -1,


      //用户标签
      userTagArray:[
        {label: "不限制",value: -1},
        {label: "付费认证",value: 1},
        {label: "临时交友",value: 2}
      ],
      userTag: -1,

      passLoading: false,
      showLoading: false,
      hideLoading: false,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4}
      ],
      searchType: 2,
      searchValue: '',

      //刷新组
      colList: ['时间', '头像', '用户信息', '被下载次数', '身份认证总状态', '微信二维码', '人工审核', '通过码', '状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],

      limitState: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = 2;
      this.overallAuthState = -1;
      this.isUse = 0;
      this.showState = 0;
      this.hideState = -1;
      this.state = 1;
      this.totalState = -1;
      this.isDel = -1;
      this.isVerify = -1;
      this.userTag = -1;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      this.throughCode = null;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['overallAuthState'] = this.overallAuthState;
      param['isUse'] = this.isUse;
      param['state'] = this.state;
      param['showState'] = this.showState;
      param['hideState'] = this.hideState;
      param['totalState'] = this.totalState;
      param['isDel'] = this.isDel;
      param['isVerify'] = this.isVerify;
      param['userTag'] = this.userTag;
      param['throughCode'] = this.throughCode;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getWeChatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //图片预览

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['user_log'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '被下载次数') {
        Dialog.open({
          title: '下载用户列表',
          component: CopyNumDialog,
          data: {
            id: row.userId
          },
          close: () => {
          }
        })
      }


    },


    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessage,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },


    //批量通过
    batchPass() {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量通过选中的用户？').then(() => {
          this.passLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = 2;
          param['imMsg'] = '';
          postFormData(batchUpdateWeChatState,param).then(function(data){
            let {code,msg} = data;
            if(code == 200){
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++) {
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0) {
                _this.getPage(false);
              }
            }else{
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            _this.passLoading = false;
          })
              .catch(function(response){
                _this.passLoading = false;
              })
        })
            .catch(() => {})
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    //单个通过
    singlePass(idx, row) {
      this.$confirm('确认通过用户【'+ row.nickName +'】？').then(() => {
        row.sPassLoading = true;
        let idArr = []
        idArr.push(row.userId)
        let _this = this;
        let param = {};
        param['idArr'] = idArr;
        param['state'] = 2;
        param['imMsg'] = '';
        postFormData(batchUpdateWeChatState,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList.splice(idx, 1)
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.sPassLoading = false;
        })
            .catch(function(){
              row.sPassLoading = false;
            })
      })
          .catch(() => {})
    },


    //批量拒绝
    batchReject() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '发送不通过原因',
          component: WeChatRejectDialog,
          data: {
            ids: this.idArray,
            width: '500px'
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++) {
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0) {
              this.getPage(false);
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    //单个拒绝
    singleReject(idx, row) {
      let idArr = []
      idArr.push(row.userId)
      Dialog.open({
        title: '发送不通过【'+ row.nickName +'】的原因',
        component: WeChatRejectDialog,
        data: {
          ids: idArr,
          width: '500px'
        },
        confirm: () => {
          this.pageDataList.splice(idx,1)
        }
      })
    },

    //批量展示/隐藏
    batchShowHide(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量' + (state==1?'【展示】':'【隐藏】') + '选中的用户？').then(() => {
          if(state == 1) {
            this.showLoading = true;
          }else {
            this.hideLoading = true;
          }
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['showState'] = state;
          postFormData(batchUpdateWeChatShowState,param).then(function(data){
            let {code,msg} = data;
            if(code == 200){
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              _this.getPage();
            }else{
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            _this.showLoading = false;
            _this.hideLoading = false;
          })
              .catch(function(){
                _this.showLoading = false;
                _this.hideLoading = false;
              })
        })
            .catch(() => {})
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    //单个展示/隐藏
    singleShowHide(state, idx, row) {
      this.$confirm('确认' + (state==1?'【展示】':'【隐藏】') + '用户【'+ row.nickName +'】？').then(() => {
        if(state == 1) {
          row.sShowLoading = true;
        }else {
          row.sHideLoading = true;
        }
        let idArr = []
        idArr.push(row.userId)
        let _this = this;
        let param = {};
        param['idArr'] = idArr;
        param['showState'] = state;
        postFormData(batchUpdateWeChatShowState,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.showState = state;
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.sShowLoading = false;
          row.sHideLoading = false;
        })
            .catch(function(){
              row.sShowLoading = false;
              row.sHideLoading = false;
            })
      })
          .catch(() => {})
    },

    getThroughCodeList() {
      getFormData(getCommonSysParam).then((data)=>{
        let {code,msg} = data;
        if(code == 200){
          let list = data.data.wechatThroughCodeList
          let arr = [];
          for(let i=0; i < list.length; i++) {
            arr.push({label : list[i], value : list[i]})
          }
          this.throughCodeArray = this.throughCodeArray.concat(arr);
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    updateHideState(row) {
      Dialog.open({
        title: '更新【'+ row.nickName +'】的微信隐藏状态',
        component: HideStateDialog,
        data: {
          id: row.userId,
          hideState: row.hideState,
          width: '500px'
        },
        confirm: (result) => {
          row.hideState = result.hideState
        }
      })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getThroughCodeList();
  }
}
</script>

<style scoped>
.playBtn {
  font-size: 5em;
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  font-size: 5em;
  color: #3a8ee6;
}
</style>
